import React, { useEffect, useState } from "react";

import Inputfield from "../customComponents/Inputfield";
import Button from "../customComponents/Button";
import { ReactSession }  from 'react-client-session';
// import Qastan from "@qastanfit/logger"

export default function ResetPasswordForm({code, setshowSuccess}){

    const [content_state, setcontent_state] = useState({});
	useEffect(()=>{
		const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);
        }
        fetchData();
	}, [])


    const [pw1, setpw1] = useState('');
    const [pw2, setpw2] = useState('');

    const [error_pw1, seterror_pw1] = useState(false);
    const [error_pw2, seterror_pw2] = useState(false);

    const handleChangePassword = () =>{
        if(pw1 === ""){
            seterror_pw1(true);
        }

        if(pw2 === ""){
            seterror_pw2(true);
            return;
        }

        if((pw1 !== pw2) && (pw1 !== "") && (pw2 !== "")){
            seterror_pw1(true);
            seterror_pw2(true);
            return;
        }

        if(pw1 === pw2){
            const passwordResetData = {
                "code": code,
                "password": pw1
            }
            console.log(passwordResetData);
            fetch(process.env.REACT_APP_SERVER_LINK+"passwordReset", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(passwordResetData)
            }).then(
                res => res.json()
            ).then(
                json => {
                    if(json.errorcode !== 0){console.log(json)}
                    setshowSuccess(true);

                    // Qastan.addLog({
                    //     "level":Qastan.level.Info,
                    //     "type":Qastan.type.User_action,
                    //     "details": {
                    //         "title": "Reset password",
                    //         "description": "User set new password",
                    //         "eventtype": "onresetpassword",
                    //     }
                    // })
                }
            )
        }
    }

	return (
		<>
            <div onKeyPress={(e) => e.key === 'Enter' && handleChangePassword()}>
                <h1 style={{margin:"2rem 0 1rem 0"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.newpassword_title ? content_state[ReactSession.get("language")].ResetPassword.newpassword_title :  "New password") : ""}</h1>
                <div style={{width:"100%"}}>
                    <Inputfield type="password" placeholder={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.password_placeholder ? content_state[ReactSession.get("language")].ResetPassword.password_placeholder :  "Password") : ""} autofocus onChange={(e)=>{setpw1(e.currentTarget.value); seterror_pw1(false); seterror_pw2(false)}} error={error_pw1}/>
                    <Inputfield type="password" placeholder={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.repeatpassword_placeholder ? content_state[ReactSession.get("language")].ResetPassword.repeatpassword_placeholder :  "Repeat password") : ""} onChange={(e)=>{setpw2(e.currentTarget.value); seterror_pw1(false); seterror_pw2(false)}} error={error_pw2}/>
                </div>
                <div style={{marginTop:"2rem", textAlign:"center"}}><Button value={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ResetPassword ? (content_state[ReactSession.get("language")].ResetPassword.confirmpassword_button ? content_state[ReactSession.get("language")].ResetPassword.confirmpassword_button :  "Confirm password") : ""} onClick={()=>handleChangePassword()}/></div>
            </div>
		</>
  	);
}